<template>
  <RouterView />
</template>

<script>
export default {
  components: {},
};
</script>

<style lang="scss"></style>
